import { useWindowSize } from '../hooks/useWindowSize';
import { screenSizes } from '../constants/screenSizes';

export const IsSmallSizeScreen = () => {
  const windowSize = useWindowSize();
  return windowSize.width < screenSizes.small;
};
